import financesGraphic from "@/shared/assets/illustrations/finances-graphic.svg";

import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

export function createAccountTypesScreens(firstName: string): FlowScreenConfig[] {
  return [
    {
      id: "account_types_intro",
      layout: "full",
      imageSrc: financesGraphic,
      imageSize: "md",
      imagePosition: "right",
      verticalCenter: true,
      sectionLabel: "Section 2",
      maxWidth: "4xl",
      title: `Let's organize ${firstName}'s finances`,
      subtitle: "We'll help you find and organize financial accounts, assets, and debts.",
      getButtonText: () => "Get started",
    },
  ];
}
